import React, { useEffect, HTMLAttributes } from 'react'
import { keycloak } from '../lib'

export const AppMenuMountDiv = (props: HTMLAttributes<HTMLDivElement>) => {
  const token = keycloak.token
  useEffect(() => {
    if (token) {
      // @ts-expect-error // tomraMenu is loaded from external script
      window.tomraMenu.mount(token)
    }
  }, [token])

  return <div id="menu-root" {...props} />
}
